import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "../api";

const DURUMLAR = ["Yeni", "Arandı", "Randevu", "Teklif", "Satış", "Kayıp"];

function exportCsv(rows) {
  const cols = ["ad", "telefon", "email", "proje", "kaynak", "durum", "atanan"];
  const csv = [cols.join(",")].concat(rows.map((r) => cols.map((c) => `"${(r[c] || "").toString().replace(/"/g, '""')}"`).join(","))).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv" });
  const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = "leadler.csv"; a.click();
}

export default function Leads() {
  const qc = useQueryClient();
  const { data: leads = [], isLoading } = useQuery({ queryKey: ["admin-leads"], queryFn: async () => (await api.get("/admin/leads")).data });
  const [gorunum, setGorunum] = useState("liste");
  const [ara, setAra] = useState("");
  const [durumF, setDurumF] = useState("");

  const durumDegis = async (id, durum) => {
    const body = { durum };
    if (durum === "Kayıp") { const neden = prompt("Kayıp nedeni:"); body.add_note = `Kayıp nedeni: ${neden || "-"}`; }
    await api.put(`/admin/leads/${id}`, body);
    qc.invalidateQueries({ queryKey: ["admin-leads"] }); toast.success("Durum güncellendi");
  };

  const filtreli = leads.filter((l) =>
    (!ara || (l.ad + l.telefon + l.proje).toLowerCase().includes(ara.toLowerCase())) && (!durumF || l.durum === durumF));

  if (isLoading) return <p className="veri">Yükleniyor…</p>;
  return (
    <div>
      <div className="a-satir" style={{ justifyContent: "space-between", marginBottom: 16 }}>
        <h1 style={{ fontFamily: "var(--display)", fontSize: 26 }}>CRM / Lead</h1>
        <div className="a-satir">
          <button className={`a-btn hayalet kucuk`} onClick={() => setGorunum(gorunum === "liste" ? "kanban" : "liste")} data-testid="crm-gorunum">{gorunum === "liste" ? "Kanban" : "Liste"}</button>
          <button className="a-btn hayalet kucuk" onClick={() => exportCsv(leads)} data-testid="crm-export">Excel (CSV)</button>
        </div>
      </div>
      <div className="a-arac">
        <input placeholder="Ara…" value={ara} onChange={(e) => setAra(e.target.value)} data-testid="crm-ara" />
        <select value={durumF} onChange={(e) => setDurumF(e.target.value)}><option value="">Tüm durumlar</option>{DURUMLAR.map((d) => <option key={d}>{d}</option>)}</select>
      </div>

      {gorunum === "liste" ? (
        <table className="a-tablo" data-testid="crm-tablo">
          <thead><tr><th>Ad</th><th>Telefon</th><th>Proje</th><th>Kaynak</th><th>Atanan</th><th>Durum</th></tr></thead>
          <tbody>
            {filtreli.map((l) => (
              <tr key={l.id} data-testid={`lead-${l.id}`}>
                <td>{l.ad}</td><td className="sayi">{l.telefon}</td><td>{l.proje}</td><td>{l.kaynak}</td><td>{l.atanan || "-"}</td>
                <td><select value={l.durum} onChange={(e) => durumDegis(l.id, e.target.value)} data-testid={`lead-durum-${l.id}`}>{DURUMLAR.map((d) => <option key={d}>{d}</option>)}</select></td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="kanban" data-testid="crm-kanban">
          {DURUMLAR.map((d) => (
            <div className="kanban-kol" key={d}>
              <h4>{d} ({filtreli.filter((l) => l.durum === d).length})</h4>
              {filtreli.filter((l) => l.durum === d).map((l) => (
                <div className="kanban-kart" key={l.id}><b>{l.ad}</b><span className="veri">{l.telefon}</span></div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
